import { useState } from 'react';
import { useDebounce } from '@trukt/react-hooks/useDebounce';
import { TextField } from '../../../inputs/TextField';
import { PageNumberProps } from './PageNumber.types';
import { useStyles } from './PageNumber.styles';

const INITIAL_PAGE_NUMBER = '1';

const PageNumberInput = ({
  onPageSelect = () => {},
  page,
  totalPages = 1,
  isActive,
  isInfinite = false,
  isNextPageAvailable = true,
}: PageNumberProps) => {
  const styles = useStyles(isActive);
  const handleInputChange = useDebounce(onPageSelect, 500);
  const [pageNumber, setPageNumber] = useState(() => String(page));

  const getIsEmptyValue = (value: string) => {
    return !value.trim().length;
  };

  return (
    <TextField
      type="number"
      css={styles.label}
      value={pageNumber}
      onChange={({ target: { value } }) => {
        const parsedNumber = value.trim().length ? Number(value) : 1;
        if (getIsEmptyValue(value)) {
          setPageNumber('');
          return;
        }
        const isValidPassNewPage = isInfinite ? isNextPageAvailable : parsedNumber <= totalPages;
        if (parsedNumber > 0 && isValidPassNewPage) {
          setPageNumber(String(parsedNumber));
          handleInputChange(parsedNumber);
        }
      }}
      onBlur={() => {
        if (getIsEmptyValue(pageNumber)) {
          setPageNumber(INITIAL_PAGE_NUMBER);
        }
      }}
    />
  );
};

export const PageNumber = (props: PageNumberProps) => (
  <PageNumberInput key={props.page} {...props} />
);
